import { Component, inject, input, OnInit, REQUEST } from '@angular/core';
import { Router } from '@angular/router';
import { SsrService } from '@hrra/core';
import { ErrorTypeEnum } from '@hrra/ui';
import { LogginService } from '@hrra/core';

@Component({
  selector: 'app-not-existing-page',
  templateUrl: './redesign/not-existing-page.component.html',
  styleUrls: ['./redesign/not-existing-page.component.scss'],
  standalone: false
})
export class NotExistingPageComponent implements OnInit {
  private ssr = inject(SsrService);
  private request = inject(REQUEST);
  private router = inject(Router);
  private logger = inject(LogginService).createLogger('not-existing-page-component');

  hideDefaultMessage = input<boolean>(false);
  errorType = input<ErrorTypeEnum>(ErrorTypeEnum.NotFound);

  ngOnInit(): void {

    if (this.errorType() == ErrorTypeEnum.NotFound) {
      if (this.request !== null && this.request.url !== undefined) {
        this.logger.warn('Request url not found for : ' + this.request.url);
      }
      else {
        this.logger.error('Reqest is null, url not found');
      }

      this.ssr.setStatusNotFound();
    }
    else if (this.errorType() == ErrorTypeEnum.NotAvailable) {
      this.ssr.setStatusNotAvailable();
    }
  }

  onGoHome() {
    this.router.navigate(['/']);
  }
}
